import { FC } from 'react';

import { Box, MantineBreakpoint } from '@mantine/core';

const DCIDE: FC<{
    width?: number;
    height?: number;
    color?: string;
    responsiveBreakpoint?: MantineBreakpoint;
}> = ({ width, height, color = 'black', responsiveBreakpoint }) => {
    return (
        <>
            <Box
                component="svg"
                viewBox="0 0 940 142"
                width={width}
                height={height}
                fill={color}
                visibleFrom={responsiveBreakpoint}
            >
                <path
                    fillRule="evenodd"
                    d="M736.885 99.54c0-8.507 6.994-15.475 15.533-15.475h19.985l13.353-26.513h-33.247c-23.255 0-42.149 18.822-42.149 41.987 0 23.166 18.894 41.988 42.149 41.988H940v-26.514H752.418c-8.63 0-15.533-6.877-15.533-15.474Z"
                    clipRule="evenodd"
                />
                <path d="M939.818.09h-209.11v26.514h209.11V.091Z" />
                <path
                    fill="#26A9E0"
                    fillRule="evenodd"
                    d="m809.101 57.552-13.263 26.513h44.33l13.353-26.513h-44.42ZM863.695 84.065h44.33l13.353-26.513h-44.329l-13.354 26.513Z"
                    clipRule="evenodd"
                />
                <path
                    fillRule="evenodd"
                    d="M631.239 0h-137.53v26.514h137.53c24.526 0 44.329 19.817 44.329 44.159s-19.893 44.159-44.329 44.159h-137.53v26.514h137.53c39.242 0 71.036-31.672 71.036-70.764C702.275 31.491 670.481 0 631.239 0ZM290.684 114.922c-24.526 0-44.329-19.817-44.329-44.159s19.803-44.25 44.329-44.25h137.53V0h-137.53c-39.242 0-71.036 31.672-71.036 70.763 0 39.092 31.794 70.764 71.036 70.764h137.53v-26.514h-137.53v-.091ZM137.621 0H0v26.514h137.53c24.526 0 44.329 19.817 44.329 44.159s-19.893 44.159-44.329 44.159H0v26.514h137.53c39.242 0 71.036-31.672 71.036-70.764C208.566 31.491 176.772 0 137.621 0Z"
                    clipRule="evenodd"
                />
                <path d="M474.269 0h-26.616v141.436h26.616V0Z" />
            </Box>

            {responsiveBreakpoint && (
                <Box
                    component="svg"
                    viewBox="0 0 230 142"
                    width={width}
                    height={height}
                    fill="#000"
                    hiddenFrom={responsiveBreakpoint}
                >
                    <path
                        fillRule="evenodd"
                        d="M26.525 99.448c0-8.506 6.995-15.473 15.533-15.473h19.985L75.396 57.46H42.15C18.894 57.46 0 76.283 0 99.448c0 23.166 18.895 41.988 42.15 41.988H229.64v-26.514H42.058c-8.63 0-15.533-6.877-15.533-15.474Z"
                        clipRule="evenodd"
                    />
                    <path d="M229.459 0H20.348v26.514h209.111V0Z" />
                    <path
                        fill="#26A9E0"
                        fillRule="evenodd"
                        d="M98.741 57.46 85.48 83.976h44.329l13.353-26.514h-44.42ZM153.336 83.975h44.329l13.353-26.514h-44.329l-13.353 26.514Z"
                        clipRule="evenodd"
                    />
                </Box>
            )}
        </>
    );
};

export { DCIDE };
